import { Box, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { SimpleTextBox } from "../../Atoms";
import { useBRLmoney } from "../../../../hooks/useBRLmoney";
import { colors } from "../../../../theme/colors";

export function ProductComponentCancel({
  ordersXproducts,
  onClick,
  selectedPRDS,
}: {
  ordersXproducts: OrdersXproducts[];
  onClick: (prd: OrdersXproducts[]) => void;
  selectedPRDS: OrdersXproducts[];
}) {
  const { BRLmoney } = useBRLmoney();

  const verifyAlreadySelected = (prd: OrdersXproducts) => {
    const find = selectedPRDS.find(
      (item) => item.productsId === prd?.productsId
    );

    if (find) {
      const filter = selectedPRDS.filter(
        (item) => item.productsId !== prd.productsId
      );
      onClick(filter);
    } else {
      onClick([...selectedPRDS, prd]);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        minWidth: "100%",
        justifyContent: "center",
        overflowX: "auto",
        gap: 1,
      }}
    >
      {ordersXproducts?.map((item, index) => (
        <Box
          sx={{
            border: selectedPRDS.find(
              (select) => select.productsId === item.productsId
            )
              ? "1px solid green"
              : "none",
            borderRadius: 2,
            cursor: "pointer",
          }}
          maxWidth={150}
          height={300}
          overflow={"hidden"}
          key={index}
          onClick={() => {
            if (!item?.isCanceled) {
              verifyAlreadySelected(item);
            }
          }}
        >
          {item?.isCanceled && (
            <Box
              sx={{
                background: "red",
                position: "absolute",
                transform: "rotate(45deg)",
                width: 170,
                borderRadius: 2,
                mt: 15,
                ml: -1,
                zIndex: 5,
              }}
            >
              <Typography textAlign={"center"} color="#FFFFFF">
                CANCELADO
              </Typography>
            </Box>
          )}
          <img
            src={item?.Products?.productsImages[0]?.code}
            style={{
              objectFit: "contain",
              width: 150,
              height: 150,
              borderRadius: 5,
              background: grey[200],
              opacity: item?.isCanceled ? 0.5 : 1,
            }}
            alt={item?.Products?.name}
          />
          <SimpleTextBox
            title=""
            description={`x${item?.quantity} - ${item?.Products?.name}`}
            height={90}
            descriptionColor={item?.isCanceled ? colors.gray[400] : undefined}
          />
          <SimpleTextBox
            title="Bought price"
            description={BRLmoney(item?.boughtPrice)}
            descriptionColor={item?.isCanceled ? colors.gray[400] : undefined}
            titleColor={item?.isCanceled ? colors.gray[400] : "black"}
          />
        </Box>
      ))}
    </Box>
  );
}
